import React from 'react'
import PropTypes from 'prop-types'

import AttachmentsList from 'components/AttachmentsList'

import styles from './styles'

function ProcessAnswer(props) {
  const { questionData } = props
  const answers = questionData?.answer?.answer_object
  const classes = styles()

  return (
    <div className={classes.root}>
      <h2>Processo nº {questionData.occurrence.number}</h2>
      <div className={classes.formWrapper}>
        <h3>Pergunta:</h3>
        <p>{questionData.text}</p>

        {answers && (
          <React.Fragment>
            <h3>Resposta:</h3>
            <div className={classes.subject}>
              <p>
                <span>Objeto do processo: </span> {answers.process_object}
              </p>
              <p>
                <span>Status atual do processo: </span> {answers.process_status}
              </p>

              {answers.legal_advice ? (
                <p>
                  <span>
                    Parecer do advogado que acompanha/acompanhou o processo:{' '}
                  </span>
                  {answers.legal_advice}
                </p>
              ) : null}

              {answers.attachments.length > 0 ? (
                <AttachmentsList
                  expanded
                  attachments={answers.attachments}
                  title="Principais peças do caso"
                />
              ) : null}
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  )
}

ProcessAnswer.propTypes = {
  questionData: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    text: PropTypes.string,
    occurrence: PropTypes.object,
    answered: PropTypes.bool.isRequired,
    subject: PropTypes.string.isRequired,
    answer: PropTypes.object,
  }).isRequired,
}

export default ProcessAnswer
